import { defineStore } from 'pinia'
import { fetchExhibitionGroup } from '~/api/exhibition'
import _ from 'lodash'

export const useSessionStore = defineStore('session', {
    state: () => ({
        sessions: [] as Record<string, any>[]
    }),

    actions: {
        setSessions(sessions: Record<string, any>[]) {
            this.sessions = sessions
        },

        async fetchSessions(exhibitionId: number) {
            // 获取同届展会
            const res = await fetchExhibitionGroup({ id: exhibitionId })
            if (_.get<any, string>(res, 'code') === ResponseCode.SUCCESS) {
                res?.data.groupList?.forEach((item: any) => {
                    const startTime = item.startTime?.slice(0, 10).replace(/-/g, '.')
                    const endTime = item.endTime?.slice(5, 10).replace(/-/g, '.')
                    item.lunchTime = startTime + '-' + endTime
                })
                const data = res?.data?.groupList?.filter((item: any) => !!item.exhibitionName)
                this.setSessions(data)
            }
        }
    }
}) 